import { ProductDowntimeDto } from "src/dtos/productDowntime/ProductDowntimeDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export interface PRD4060_R01Dto extends ProductDowntimeDto {
    
}

/**
 * 생산 실적 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultPRD4060_R01Dto: PRD4060_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	downtimeNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productEmp: '',
	productEmpNm: '',
	fromTime: toLocalDateTime(new Date()),
	toTime: toLocalDateTime(new Date()),
	downtimeCase: '',
	remark: '',

	inserted: false,
	isModified: false

};
